<template>
  <v-app>
    <v-content>
      <sponsor-form v-if="freeGroups.length > 0"></sponsor-form>
    </v-content>
  </v-app>
</template>

<script>
import SponsorForm from "./components/SponsorForm";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "App",
  async created() {
    await this.getGroups();
  },
  components: {
    SponsorForm,
  },
  computed: {
    ...mapGetters(["freeGroups"]),
  },
  methods: {
    ...mapActions(["getGroups"]),
  },
};
</script>
